import { render, staticRenderFns } from "./translateIntalnationModule.vue?vue&type=template&id=dd5e91c2&scoped=true&"
import script from "./translateIntalnationModule.vue?vue&type=script&lang=js&"
export * from "./translateIntalnationModule.vue?vue&type=script&lang=js&"
import style0 from "./translateIntalnationModule.vue?vue&type=style&index=0&id=dd5e91c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5e91c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VExpandTransition,VIcon,VRow})
